import type { IconData } from '@stacksjs/iconify-core'

export const branchF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4 11.856v3.173a3.001 3.001 0 1 1-2 0V6.687a3.001 3.001 0 1 1 2 0v2.34c.312-.11.647-.17.997-.171l6.037-.006a1 1 0 0 0 .999-1V6.699A3.001 3.001 0 0 1 13 .858a3 3 0 0 1 1.033 5.817V7.85a3 3 0 0 1-2.997 3l-6.037.006a1 1 0 0 0-.999 1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default branchF
